<div class="create-channel-page">

  <!-- ─── Page Header ─────────────────────────────────────────────────── -->
<div class="page-header__bg">
  <app-page-header
    section="Administration / Channels"
    [pageTitle]="headerTitle"
    [badgeText]="headerBadge"
    [subtitle]="codePreview + ' · No linked POS yet · New channel'"
    [actions]="headerActions"
    (actionClick)="onHeaderAction($event)">
  </app-page-header>
</div>
  <!-- ─── Tabs Bar ──────────────────────────────────────────────────────── -->
  <div class="tabs-bar">
    <button class="tab-btn" [class.tab-btn--active]="activeTab === 'identity'"
      (click)="setActiveTab('identity')">
    <img src="assets/icons/identity.svg" alt="User Management" width="18" height="18" />
      Identity
    </button>

    <button class="tab-btn" [class.tab-btn--active]="activeTab === 'fieldRules'"
      (click)="setActiveTab('fieldRules')">
    <img src="assets/icons/field_rules.svg" alt="User Management" width="18" height="18"/>
      Field rules
      <span class="tab-count">{{ fieldRules.length }}</span>
      <span class="tab-dot"></span>
    </button>

    <button class="tab-btn" [class.tab-btn--active]="activeTab === 'surveys'"
      (click)="setActiveTab('surveys')">
    <img src="assets/icons/surveys.svg" alt="User Management" width="18" height="18"/>
      Surveys
      <span class="tab-count">{{ linkedSurveys.length }}</span>
      <span class="tab-dot"></span>
    </button>

    <button class="tab-btn" [class.tab-btn--active]="activeTab === 'skuRules'"
      (click)="setActiveTab('skuRules')">
    <img src="assets/icons/sku_rules.svg" alt="User Management" width="18" height="18"/>
      SKU rules
      <span class="tab-count">{{ allowedSkuCount }}/{{ restrictedSkuCount }}</span>
    </button>

    <!-- <button class="tab-btn" [class.tab-btn--active]="activeTab === 'impactPreview'"
      (click)="setActiveTab('impactPreview')">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" class="tab-icon">
        <path d="M2 10L5.5 6L8 8.5L11 4.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M2 12h10" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
      </svg>
      Impact preview
    </button> -->
  </div>

  <!-- ─── Tab Content ───────────────────────────────────────────────────── -->
  <div class="tab-content">

    @if (activeTab === 'identity') {
    <div class="tab-pane">
      <app-channel-identity-tab
        [formData]="formData"
        [submitted]="submitted"
        [(nameError)]="nameError"
        [(codeError)]="codeError"
        (codeValidationChange)="codeValidationState = $event">
      </app-channel-identity-tab>
    </div>
    }

    @if (activeTab === 'fieldRules') {
    <div class="tab-pane">
      <app-channel-field-rules-tab
        [fieldRules]="fieldRules"
        (fieldRulesChange)="fieldRules = $event">
      </app-channel-field-rules-tab>
    </div>
    }

    @if (activeTab === 'surveys') {
    <div class="tab-pane">
      <app-channel-surveys-tab
        [linkedSurveys]="linkedSurveys"
        [availableSurveys]="availableSurveys"
        (linkedSurveysChange)="linkedSurveys = $event">
      </app-channel-surveys-tab>
    </div>
    }

    @if (activeTab === 'skuRules') {
    <div class="tab-pane">
      <app-channel-sku-rules-tab
        [skuRules]="skuRules"
        (skuRulesChange)="skuRules = $event">
      </app-channel-sku-rules-tab>
    </div>
    }

    <!-- @if (activeTab === 'impactPreview') {
    <div class="tab-pane">
      <app-channel-impact-preview-tab
        [formData]="formData"
        [fieldRules]="fieldRules"
        [linkedSurveys]="linkedSurveys"
        [skuRules]="skuRules">
      </app-channel-impact-preview-tab>
    </div>
    } -->

  </div><!-- /tab-content -->

  <!-- ─── Confirm Create Modal ──────────────────────────────────────────── -->
  @if (showConfirmModal) {
    <app-confirm-action-modal
      [data]="confirmModalData"
      [isOpen]="showConfirmModal"
      (actionTriggered)="onModalAction($event)"
      (dismissed)="onModalDismiss()">
    </app-confirm-action-modal>
  }

  <!-- ─── Success Overlay ───────────────────────────────────────────────── -->
  @if (creationSuccess) {
  <div class="success-overlay">
    <div class="success-card">
      <div class="success-icon-circle">
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
          <path d="M5 13.5L10 18.5L21 7.5" stroke="#3da66e" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <h2 class="success-title">Channel Created</h2>
      <p class="success-name">{{ formData.name }}</p>
      <p class="success-sub">Code: <strong>{{ formData.code }}</strong> · {{ formData.active ? 'Active' : 'Inactive' }}</p>
      <div class="success-actions">
        <button class="btn-discard" (click)="redirectToList()">Go to channels</button>
      </div>
    </div>
  </div>
  }

</div>
